'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _starRatings = require('./star-ratings');

var _starRatings2 = _interopRequireDefault(_starRatings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill for ie
Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

exports.default = _starRatings2.default;